import React from "react";
function SearchComponent({ cond, setCond }) {
  //block are   so make sure to hide them
  return (
    <div className="flex">
      <div className="relative ml-1  ">
        <input
          type="text"
          className="w-2/3 py-2 pl-10 pr-5  bg-cusDarkBlack border border-cusWhite border-opacity-40 rounded-3xl  focus:border-cusWhite  focus:outline-none focus:ring focus:ring-opacity-40 focus:ring-cusWhite text-cusWhite  "
          placeholder="Enter the Pass"
          onChange={(e) => {
            setCond(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
export default SearchComponent;
